/**
 * sirus/BagBar — 3.3.5 bottom-right bag row: the backpack plus four bag
 * slots (empty until bags drop / are bought). Genuine interface art from
 * the extracted Sirus MPQs (Button-Backpack-Up + quickslot frame).
 *
 * Clicking the backpack toggles the all-bags panel (same flag the MicroMenu
 * uses). The four extra slots are visual + tooltip stubs until bag items
 * land in the equipment pipeline.
 */

import { useState } from 'react';
import type { CSSProperties } from 'react';

import { useUI } from '../../state/store.js';
import { useUiPanels } from './MicroMenu.js';

const ART = `${import.meta.env.BASE_URL}ui-sirus/Interface/BUTTONS`;

export function BagBar() {
  const stage = useUI((s) => s.stage);
  const bagsOpen = useUiPanels((s) => s.bagsAll);
  const [hover, setHover] = useState<number | null>(null);

  if (stage !== 'world') return null;

  const slot = (i: number): CSSProperties => ({
    width: 'calc(var(--aiwari-slot) * 0.82)',
    height: 'calc(var(--aiwari-slot) * 0.82)',
    padding: 0,
    border: 'none',
    cursor: i === 0 ? 'pointer' : 'default',
    backgroundColor: 'rgba(10,8,6,0.55)',
    backgroundImage: i === 0
      ? `url("${ART}/Button-Backpack-Up.png")`
      : `url("${ART}/UI-Quickslot.png")`,
    backgroundSize: i === 0 ? 'cover' : '160% 160%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: 4,
    boxShadow: i === 0 && bagsOpen
      ? '0 0 8px rgba(255,212,121,0.6), inset 0 0 3px rgba(0,0,0,0.8)'
      : 'inset 0 0 4px rgba(0,0,0,0.8)',
    filter: hover === i ? 'brightness(1.3)' : 'none',
    transition: 'filter 100ms',
  });

  return (
    <div
      className="aiwari-bag-bar"
      style={{
        position: 'fixed',
        right: 8,
        bottom: 8,
        zIndex: 30,
        display: 'flex',
        gap: 2,
        alignItems: 'flex-end',
        pointerEvents: 'auto',
      }}
    >
      {[0, 1, 2, 3, 4].map((i) => (
        <button
          key={i}
          type="button"
          title={i === 0 ? 'Рюкзак (B)' : 'Пустой слот сумки'}
          onMouseEnter={() => setHover(i)}
          onMouseLeave={() => setHover(null)}
          onClick={() => { if (i === 0) useUiPanels.getState().toggle('bagsAll'); }}
          style={slot(i)}
        />
      ))}
    </div>
  );
}
